module.exports = ".container {\n    width: 100%;\n}\n.currency-wrapper {\n    margin-left: 15px;\n}\nlabel {\n    text-align: left !important;\n    padding-bottom: 15px;\n}\n.form-control {\n    width: 120px;\n    display: inline-block;\n}\n.select-payment {\n    width: 190px !important;\n}\ntextarea {\n    width: 100% !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/account-data/credit/approve/approve.component.css
// module id = ./src/app/agora/components/account-data/credit/approve/approve.component.css
// module chunks = main